import React from 'react';
import PropTypes from 'prop-types';

export default function LegendLine(props) {
  return (
    <svg width={40} height={12} viewBox="0 0 40 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M0 0H40V12H0V0Z" fill={props.color || '#dddddd'} />
      <path d="M0 3H40V9H0V3Z" fill="#343434" />
    </svg>
  );
}

LegendLine.propTypes = {
  color: PropTypes.string
};
